import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SystemUnavailablePage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
        minHeight="100vh"
      >
        <Typography variant="h4" component="h1" gutterBottom>
          Sistema Indisponível
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          O sistema não está respondendo no momento. Por favor, entre em contato com o suporte.
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate('/login', { replace: true })}
          className="mt-3"
        >
          Voltar para login
        </Button>
      </Box>
    </Container>
  );
};

export default SystemUnavailablePage;

